// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"79":"component---src-pages-home-js","883":"component---src-pages-404-js","886":"component---src-templates-article-js"}[chunkId] + "-" + {"79":"956dda09bce47f228a52","883":"5fa543a65075c99fc3c4","886":"8bc8c622e001f9b4b30d"}[chunkId] + ".js";
};